module.exports = __webpack_public_path__ + "img/RankList-title.cbd8761e.png";